// extracted by mini-css-extract-plugin
export var hasMarginStyle = "section-module--hasMarginStyle--Hg6fR";
export var hasPaddingStyle = "section-module--hasPaddingStyle--nEO8g";
export var sectionStyle = "section-module--sectionStyle--6etXY";